@for (subPostObject of subPostList; track subPostObject) {
<div class="box">
  <article class="media">
    <figure class="media-left">
      <p class="image is-32x32">
        @if (!subPostObject.user_detail.user_icon) {
        <empty-uname
          [userName]="subPostObject.user_detail.full_name"
          [detailHeadProfile]="true"
        ></empty-uname>
        } @if (subPostObject.user_detail.user_icon) {
        <img [src]="profileUrl + subPostObject.user_detail.user_icon" />
        }
      </p>
    </figure>
    <div class="media-content">
      <!-- Sub Post name display -->
      @if (!subPostObject.editSubPostName) {
      <div class="content">
        <div class="post-detail">
          <span class="creater-name">{{
            subPostObject.user_detail.full_name
          }}</span>
          <span class="sub-post-content">{{
            subPostObject.sub_post_name
          }}</span>
          @if (subPostObject.canEdit) {
          <a
            class="has-text-info"
            [ngClass]="{ 'disable-fa-edit': subPostObject.editDisabled }"
          >
            <i
              class="pi pi-pen-to-square pad-5-2"
              (click)="editSubPostName(subPostObject)"
            ></i>
          </a>
          }
        </div>
        <span>
          @if (!subPostObject.is_viewed) {
          <span
            class="tag is-primary"
            style="height: 1.5em; border-radius: 2px; font-size: 10px"
            >NEW</span
          >
          }&nbsp;
          <small class="is-size-7 text-clr-grey">{{
            subPostObject.createdAt | date : "MMM d, y h:mm a"
          }}</small>
          <!-- <small class="is-size-7 text-clr-grey">{{subPostObject.createdAt | date:'medium'}}</small> -->
          <small class="pad-0-5">
            <a
              class="has-text-info is-small"
              (click)="openNewComment(subPostObject)"
              >Comments @if (subPostObject.commentsCount > 0) {
              <span>({{ subPostObject.commentsCount }})</span>
              }
            </a>
          </small>
        </span>
        @if (subPostObject.thumb_file_path) {
        <div class="post-attachment">
          @if (subPostObject.file_id) {
          <div
            class="post-img"
            [ngClass]="{ 'notify-play': subPostObject.playVideo }"
          >
            @if (!subPostObject.playVideo) {
            <div class="">
              <img [src]="subPostObject.thumb_file_path" />
              <div class="play-btn-wrapper">
                @if (subPostObject.file_type === 'video') {
                <i
                  class="fa fa-play-circle"
                  (click)="subPostObject.playVideo = !subPostObject.playVideo"
                ></i>
                }
              </div>
            </div>
            } @if (subPostObject.playVideo) {
            <div class="">
              @if (subPostObject.file_type ==='video') {
              <video controls controlsList="nodownload" autoplay>
                <source
                  [src]="subPostObject.original_file_path"
                  type="video/mp4"
                />
              </video>
              } @if (subPostObject.file_type === 'video') {
              <i
                class="fa fa-times"
                aria-hidden="true"
                (click)="subPostObject.playVideo = !subPostObject.playVideo"
              ></i>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- Update Subpost name section -->
      @if (subPostObject.editSubPostName) {
      <div class="control edit-text-box mar-5-0">
        <input
          type="search"
          class="input"
          inputFocus
          placeholder="Type here..."
          size="{{ calcTextLength(editedSubPostDetails.sub_post_name) }}"
          [(ngModel)]="editedSubPostDetails.sub_post_name"
          (keyup.enter)="updateSubPostName(editedSubPostDetails)"
        />
        <div class="options">
          <a
            class="button is-small"
            (click)="cancelEditedSubPostName(subPostObject)"
            >Cancel</a
          >
          <a
            class="button is-link is-small mar-0-10"
            (click)="updateSubPostName(editedSubPostDetails)"
            >Save</a
          >
        </div>
      </div>
      }
      <!-- Add New Sub post section -->
      @if (subPostObject.showReply) {
      <div class="field">
        <div class="control is-expanded edit-text-box">
          <input
            type="search"
            class="input text-input"
            inputFocus
            placeholder=" Add a comment here..."
            [(ngModel)]="subPostObject.newComment"
            (keyup.enter)="createNewComment(subPostObject)"
            (keydown)="keyHandleComment($event)"
          />
          <br />
          @if (subPostObject.newComment.length >= 250) {
          <div class="errors" style="font-size: 0.9rem; color: red">
            Your comment is too long
          </div>
          }
        </div>
      </div>
      }
      <!-- End -->
      <app-comment [postComment]="subPostObject"></app-comment>
    </div>
  </article>
</div>
}
